import { render } from "./VInput.vue?vue&type=template&id=6c80ea66&scoped=true"
import script from "./VInput.vue?vue&type=script&lang=js"
export * from "./VInput.vue?vue&type=script&lang=js"

import "./VInput.vue?vue&type=style&index=0&id=6c80ea66&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c80ea66"]])

export default __exports__